<template>
    <div class="home-content">
        <div class="inner">
            <h1 class="logo">
                <SvgIcon name="logo"/>
                <span v-html="text"></span>
            </h1>
            <!-- <Loading class="static" v-if="!$store.state.user_data" />

            <div class="login-box" v-else-if="$store.state.user_data.merchant_account">
                <div class="user">
                    <figure class="avatar"><img v-if="$store.state.user_data.merchant_account.brand_logo" :src="$store.state.user_data.merchant_account.brand_logo" /></figure>
                    <p>
                        <strong>{{ $store.state.user_data.merchant_account.merchant_display_name }}</strong>
                        <span v-html="type"></span>
                    </p>
                </div>
                <div class="btn">
                    <Button :to="$store.state.user_data.creator_url" size="40" color="dark-blue">Get started</Button>
                </div>
            </div> -->
            <div class="foot">
                <SvgIcon name="power-by"/>
                <SvgIcon name="motom"/>
            </div>
            
        </div>
    </div>
</template>

<script>
import "@/assets/svg/logo.svg?sprite";
import Button from '@/components/ui/Button.vue';
import Loading from '@/components/ui/Loading.vue';
import SvgIcon from "@/components/ui/SvgIcon.vue";

export default {
    name: 'Home',

    data() {
        return {
            name: 'Joanna Buchanan',
            logo: require('@/assets/images/logo.jpg'),
            type: `Merchant <b>• Primary workspace</b>`,
            text: `Welcome to your Anchor portal, where you can manage all aspects of your creator storefront program.`,
        }
    },

    components: {
        Button,
        Loading,
        SvgIcon,
    },

    mounted() {
        if (typeof this.$route.query.welcome !== 'undefined') {
            this.text = `Welcome to your Anchor portal, where you can manage all aspects of your creator storefront program.`;
            this.link = '/landing';
            this.type = `Merchant <b>• Primary workspace</b>`;
        }

        const access_token = localStorage.getItem('access_token');
        if (!access_token) {
            this.$router.replace('/login');
        }
        else {
            setTimeout(() => {
                if (this.$store.state.user_data && this.$store.state.user_data.merchant_accounts.length === 1) {
                    if (this.$store.state.user_data.merchant_account.enable_creators_count === 0) {
                        this.$router.replace('/creator/get-started');
                    } else {
                        this.$router.replace('/creator/list');
                    }
                } else {
                    this.$router.replace('/landing');

                }
                    
            }, 1000);
        }
    },
}
</script>
<style lang="scss">
    .home-content {
        min-height: 100vh;
        background-color: var(--dark-blue);
        color: white;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .logo {
            svg {
                fill: white;
                width: 320px;
                height: 64px;
                display: block;
                margin: 0 auto;
            }

            span {
                display: block;
                text-align: center;
                font: var(--font-fg-16);
                margin: 40px 0;
            }
        }

        .login-box {
            width: 480px;
            border-radius: 10px;
            overflow: hidden;
            background-color: white;

            .user {
                display: flex;
                padding: 24px;
                align-items: center;

                .avatar {
                    height: 62px;
                    width: 62px;
                    background-color: var(--black-20);
                    overflow: hidden;
                    border-radius: 50%;

                    img {
                        height: 100%;
                        width: 100%;
                        display: block;
                        object-fit: contain;
                    }
                }

                p {
                    flex: 1;
                    padding-left: 16px;

                    strong {
                        display: block;
                        line-height: 1.2;
                        letter-spacing: 1px;
                        font: var(--font-demi-28);
                        color: var(--dark-blue);
                        margin-bottom: 1px;
                    }

                    span {
                        // font-size: 12px;
                        color: var(--black-90);

                        b {
                            font-weight: 700;
                        }
                    }
                }
            }

            .btn {
                padding: 16px 24px;
                background-color: var(--border);
                display: flex;
                justify-content: flex-end;
                
                .ui-button {
                    width: 220px;
                    text-align: center;
                }
            }
        }

        .foot {
            display: block;
            margin: 24px auto 0;
            height: 12px;
            width: 160px;
            display: flex;
            justify-content: center;
            align-items: center;

            svg{
                fill: white;
                
                &:first-child{
                    margin-right: 6px;
                    margin-left: -8px;
                }
            }
        }
    }
</style>
